import React from "react";
import Torta from "./PieChartComponent";
import Radar from "./RadarChartComponent";

function QualificationComponent(props) {
  const calificacion = (datos) => {
    const total = datos[0].dataSet
      .filter((f) => f.name !== "NS/NR")
      .reduce((pr, cur) => pr + cur.value * cur.name, 0);
    const cuantos = datos[0].dataSet
      .filter((f) => f.name !== "NS/NR")
      .reduce((pr, cur) => pr + cur.value, 0);
    const result = total / cuantos;

    return result.toFixed(2);
  };
  console.log(props);
  return (
    <>
      <div className="line line-100 align-midle">
        <div className="line line-5"></div>
        <div className="line line-30 ">
          <div className="line line-5"></div>
          <div className="line line-90 align-center ">
            <label className="line line-100 align-center client-label-second-color">
            </label>
            <Torta data={props.data} />
          </div>
          <div className="line line-5"></div>
        </div>
        <div className="line line-30">
          <Radar data={props.data} />
        </div>
        <div className="line line-30 title-page-inform-label">
          Calificación {calificacion(props.data)}
        </div>
        <div className="line line-5"></div>
      </div>
    </>
  );
}

export default QualificationComponent;
